import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS, queryClient } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyLists } from './useGetLists';
import { getQueryKey as getQueryKeyList } from './useGetListById';

// Config
import { uiConfig } from '../../../conf/lists';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.LIST);

export const useUpdateList = ({ crudConfig, sessionToken, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ update }) => Client.update(sessionToken, update.listId, update),
        onSuccess: (data, variables, context) => {
            updateCacheArray({
                queryKey: getQueryKeyLists(),
                action: CACHE_ACTIONS.UPDATE,
                primaryKey: uiConfig.primaryKey,
                data
            });
            queryClient.invalidateQueries({
                queryKey: getQueryKeyList(data.listId)
            });
            onSuccessCb?.({ context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
